<div class="wrapper item-course" *ngIf="course$ | async as course">
    <div class="course-item">
        <div class="media">
            <figure *ngIf="courseImage$ | async as courseImage">
                <da-progressive-image
                    [options]="{
                        alt: alt,
                        aspectRatios: [
                            {
                                breakpoint: 360,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 480,
                                width: 780,
                                height: 520,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 768,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 960,
                                width: 380,
                                height: 253,
                                akamaiImage: courseImage
                            },
                            {
                                breakpoint: 1120,
                                width: 480,
                                height: 320,
                                akamaiImage: courseImage
                            }
                        ]
                    }"
                ></da-progressive-image>
            </figure>
            <div class="content-md">
                <div class="headline main-title main-title-long">
                    <h6>
                        {{ courseTitle }}
                        <span class="last-word">
                            {{ lastWord }}                          
                            <span
                                class="label-bestseller"
                                *ngIf="course.keyWords && course.keyWords.length > 0"
                                [innerHTML]="course.keyWords[0]"
                            ></span>
                        </span>
                    </h6>
                </div>
                <ng-container *ngIf="showShortDesc$ | async">
                    <p *ngIf="course.training.descriptionShort" [innerHTML]="course.training.descriptionShort"></p>
                </ng-container>
                <!-- <p *ngIf="!course.training.descriptionShort">&nbsp;</p> -->
            </div>
        </div>
        <div class="inner-content inner-item">
            <div class="content-card">
                <div class="media-md">
                    <figure *ngIf="courseImage$ | async as courseImage">
                        <da-progressive-image
                            [options]="{
                                alt: alt,
                                aspectRatios: [
                                    {
                                        breakpoint: 360,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: courseImage
                                    },
                                    {
                                        breakpoint: 480,
                                        width: 780,
                                        height: 520,
                                        akamaiImage: courseImage
                                    },
                                    {
                                        breakpoint: 768,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: courseImage
                                    },
                                    {
                                        breakpoint: 960,
                                        width: 380,
                                        height: 253,
                                        akamaiImage: courseImage
                                    },
                                    {
                                        breakpoint: 1120,
                                        width: 480,
                                        height: 320,
                                        akamaiImage: courseImage
                                    }
                                ]
                            }"
                        ></da-progressive-image>
                    </figure>
                </div>
                <div class="content-lg">
                    <div class="headline main-title main-title-quick">
                        <h6>
                            {{ courseTitle }}
                            <span class="last-word">
                                {{ lastWord }}
                                <span
                                    class="label-bestseller"
                                    *ngIf="course.keyWords && course.keyWords.length > 0"
                                    [innerHTML]="course.keyWords[0]"
                                ></span>
                            </span>
                        </h6>
                    </div>
                    <ng-container *ngIf="showShortDesc$ | async">
                        <p *ngIf="course.training.descriptionShort" [innerHTML]="course.training.descriptionShort"></p>
                    </ng-container>
                    <!-- <p *ngIf="!course.training.descriptionShort">&nbsp;</p> -->
                </div>
                <div class="details details-quick">
                    <div class="inner-wrapper">
                        <div class="duration"></div>
                        <div class="wrapper" *ngIf="!course.url && course.isProduct" [innerHTML]="'courses.online' | translate"></div>
                        <div class="wrapper" *ngIf="!course.url && !course.isProduct && (course.productType === 'SEM' || course.productType === 'WRK')" [innerHTML]="'courses.presence' | translate"></div>
                        <div class="wrapper" *ngIf="!course.url && !course.isProduct && course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></div>
                        <ul [class.no-type]="course.url">
                            <li *ngFor="let item of course.divisions">
                                <span>{{ item.name }}</span>
                            </li>
                        </ul>

                        <ul *ngIf="course.trainingSegments">
                            <li *ngFor="let item of course.trainingSegments">
                                <span>{{ item }}</span>
                            </li>
                        </ul>

                        <ul *ngIf="course.productAreas">
                            <li *ngFor="let item of course.productAreas">{{ item }}</li>
                        </ul>
                    </div>
                    <div class="price" *ngIf="course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                        <span [innerHTML]="'courses.price' | translate"></span>
                        <br *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value" />
                        <span *ngIf="course.prices.length === 1 || course.prices.length > 1 && course.prices[1].value === course.prices[0].value"> {{formattedPrice$ | async}}</span>
                        <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value > 0">{{formattedPrice$ | async}} - {{formattedPrice2$ | async}}</span>
                        <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value === 0">{{formattedPrice2$ | async}}</span>
                        <span class="pro-person" [innerHTML]="'common.perPerson' | translate"></span>
                        <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                    </div>
                    <div class="price" *ngIf="course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                        <span [innerHTML]="'courses.price' | translate"></span>
                        <span> {{formattedPrice$ | async}}</span>
                        <span class="pro-person" [innerHTML]="'common.perPerson' | translate"></span>
                        <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                    </div>
                    <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                        <span [innerHTML]="'courses.noPrice' | translate"></span>
                    </div>
                </div>
            </div>

            <div class="button-wrapper">
                <a da-button [routerLink]="courseDetail" [themeType]="'Secondary'" [innerHTML]="'buttons.showDetails' | translate"></a>
                <a
                    *ngIf="course.demo && course.demo.uri && course.demo.uri !== ''"
                    class="button secondary"
                    da-button
                    themeType="Secondary"
                    (click)="openOverlay(course)"
                    [innerHTML]="'buttons.viewDemo' | translate"
                ></a>
                <a
                    *ngIf="course.url"
                    da-button
                    [routerLink]="booking"
                    [themeType]="'Primary'"
                    [innerHTML]="'buttons.bookNow' | translate"
                ></a>
                <a
                    *ngIf="!course.url && course.isProduct"
                    da-button
                    (click)="addCourseToCart()"
                    [themeType]="'Primary'"
                    [innerHTML]="'buttons.bookNow' | translate"
                ></a>
            </div>
        </div>
        <div class="details">
            <div class="inner-wrapper">
                <div class="wrapper" *ngIf="!course.url && course.isProduct">
                    <div class="wrapper" [innerHTML]="'courses.online' | translate"></div>
                </div>

                <div class="wrapper" *ngIf="!course.url && !course.isProduct">
                    <div class="wrapper" *ngIf="course.productType === 'SEM' || course.productType === 'WRK'" [innerHTML]="'courses.presence' | translate"></div>
                    <div class="wrapper" *ngIf="course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></div>
                </div>
                <ul [class.no-type]="course.url">
                    <li *ngFor="let item of course.divisions">
                        <span>{{ item.name }}</span>
                    </li>                </ul>
                <ul *ngIf="course.trainingSegments">
                    <li *ngFor="let item of course.trainingSegments">
                        <span>{{ item }}</span>
                    </li>
                </ul>
                <ul *ngIf="course.productAreas">
                    <li *ngFor="let item of course.productAreas">{{ item }}</li>
                </ul>
            </div>
            <div class="price" *ngIf="course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                <span [innerHTML]="'courses.price' | translate"></span>
                <br *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value" />
                <span *ngIf="course.prices.length === 1 || course.prices.length > 1 && course.prices[1].value === course.prices[0].value"> {{formattedPrice$ | async}}</span>
                <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value > 0">{{formattedPrice$ | async}} - {{formattedPrice2$ | async}}</span>
                <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value === 0">{{formattedPrice2$ | async}}</span>
                <span class="pro-person" [innerHTML]="'common.perPerson' | translate"></span>
                <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
            </div>

            <div class="price" *ngIf="course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                <span [innerHTML]="'courses.price' | translate"></span>
                <span> {{formattedPrice$ | async}}</span>
                <span class="pro-person" [innerHTML]="'common.perPerson' | translate"></span>
                <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
            </div>
            <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                <span [innerHTML]="'courses.noPrice' | translate"></span>
            </div>
        </div>
        <div class="button-container">
            <div class="button-wrapper quick-view">
                <a da-button [routerLink]="courseDetail" [themeType]="'Secondary'" [innerHTML]="'buttons.showDetails' | translate"></a>
                <a
                    da-button
                    *ngIf="course.demo && course.demo.uri && course.demo.uri !== ''"
                    (click)="openOverlay(course)"
                    [themeType]="'Secondary'"
                    [innerHTML]="'buttons.viewDemo' | translate"
                ></a>
                <a
                    *ngIf="course.url"
                    da-button
                    [routerLink]="booking"
                    [themeType]="'Primary'"
                    [innerHTML]="'buttons.bookNow' | translate"
                ></a>
                <a
                    *ngIf="!course.url && course.isProduct"
                    da-button
                    (click)="addCourseToCart()"
                    [themeType]="'Primary'"
                    [innerHTML]="'buttons.bookNow' | translate"
                ></a>
            </div>
        </div>
    </div>
    <div class="course-events" *ngIf="!course.isProduct && !course.url">
        <div class="inner-wrapper">
            <div class="dates" #event>
                <!-- <p
                    class="prebooking"
                    *ngIf="
                        course &&
                        course.metadata &&
                        course.metadata.waitingListEnrolable &&
                        course &&
                        course.events &&
                        !(course.events.length > 0)
                    "
                >
                    <span [innerHTML]="'events.prebookingTextNoEvents' | translate"></span>
                    <span class="button-wrapper">
                        <a da-button (click)="addToWishlist()" [themeType]="'Secondary'" [innerHTML]="'buttons.prebooking' | translate"></a>
                    </span>
                </p> -->
                <span class="title" (click)="toggleEvents(event, course.id)">
                    <div id="loader-screen" class="drg-loading-container">
                        <i class="loading-icon"></i>
                    </div>
                    <span [innerHTML]="'courses.dates' | translate"></span>
                </span>
            </div>
            <div class="table-wrapper" [class.active]="show" id="course.id" *ngIf="events$ | async as events">
                <da-events [isCourseDetails]="false" [events]="course.events" [course]="course"></da-events>
            </div>
        </div>
    </div>
</div>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="youtubeVideo"></ng-container>
    </div>
</ng-template>
<ng-template #youtubeVideo>
    <iframe id="demo" #iframe></iframe>
</ng-template>

<ng-template #warning>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warn"></ng-container>
    </div>
</ng-template>
<ng-template #warn>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInCartTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInCartText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #requiredPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="requirementsModal"></ng-container>
    </div>
</ng-template>
<ng-template #requirementsModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.preRequirements.title' | translate"></h3>
                <p [innerHTML]="'booking.preRequirements.text' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCourseDetails()"
                            [innerHTML]="'preRequirements.showDetails' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #notTheSameCurrencyPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="notTheSameCurrencyModal"></ng-container>
    </div>
</ng-template>
<ng-template #notTheSameCurrencyModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'booking.currencyWarningTitle' | translate"></h3>
                <p [innerHTML]="'booking.currencyWarningText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCart()"
                            [innerHTML]="'courses.showCart' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #warningWishlist>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warnWishlist"></ng-container>
    </div>
</ng-template>
<ng-template #warnWishlist>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInWishlistTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInWishlistText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="notification" *ngIf="showCartUpdate$ | async as showCartUpdate">
    <div class="modal">
        <div class="location-popup" [ngClass]="showCartUpdate ? 'fade' : ''">
            <div class="title">
                <span class="checked"></span>
                <span [innerHTML]="'courses.update' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span class="title-wrapper">{{ courseTitle }}</span>
                    <span *ngIf="course.price !== undefined && ( course.metadata === null || !course.metadata|| course.metadata.showPrice)">
                        {{formattedPrice$ | async}}
                        <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span>
                        <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                    </span>

                    <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                        <span [innerHTML]="'courses.noPrice' | translate"></span>
                    </div>
                </div>
                <div class="wrapper" *ngIf="!course.url && course.isProduct">
                    <div class="wrapper" [innerHTML]="'courses.online' | translate"></div>
                </div>

                <div class="wrapper" *ngIf="!course.url && !course.isProduct">
                    <div class="wrapper" *ngIf="course.productType === 'SEM' || course.productType === 'WRK'" [innerHTML]="'courses.presence' | translate"></div>
                    <div class="wrapper" *ngIf="course.productType === 'WBN'" [innerHTML]="'courses.virtual' | translate"></div>
                </div>
                <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>

<div class="notification" *ngIf="showCartUpdatePrebooking$ | async as showCartUpdatePrebooking">
    <div class="modal">
        <div class="location-popup" [ngClass]="showCartUpdatePrebooking ? 'fade' : ''">
            <div class="title">
                <span class="checked"></span>
                <span [innerHTML]="'courses.update' | translate"></span>
            </div>
            <div class="inner-wrapper">
                <div class="details">
                    <span>{{ courseTitle }}</span>

                    <div class="price">
                        <span [innerHTML]="'buttons.prebooking' | translate"></span>
                    </div>
                </div>
                <div class="wrapper">
                    <div class="wrapper" [innerHTML]="'courses.prebooking' | translate"></div>
                </div>

                <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
            </div>
        </div>
    </div>
</div>

<ng-template #warningPrebooking>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warnPrebooking"></ng-container>
    </div>
</ng-template>
<ng-template #warnPrebooking>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'addToShopingCart.courseAlreadyInWishlistTitle' | translate"></h3>
                <p [innerHTML]="'addToShopingCart.courseAlreadyInWishlistText' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                        <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
